// extracted by mini-css-extract-plugin
export default {"option":"Option_option__1BEQZ","break":"Option_break__ajhzh"};